import ProductUtils from './product-utils';
import MessagesCodesConstants from '@/components/CheckoutPage/Common/messages.codes.constants';

export default class Product {
    constructor(data) {
        data.packElements = ProductUtils.parsePackElements({...data});
        data.children = ProductUtils.parseChildren({...data});

        this.data = {...data};
        this._stockErrorMsg = null;
        this._notEligibleMsg = false;

        this._offerChoices = [];
        const dataClone = {...data};
        if(dataClone.hasOwnProperty('offerChoices') && dataClone.offerChoices){
            dataClone.offerChoices.forEach(product => {
                //console.log('product', product);
                this._offerChoices.push(new Product(product));
            });
        }

    }

    get lineId() {
        return this.data.hasOwnProperty('lineId') ? this.data.lineId : 0;
    }

    get price() {
        return this.data.hasOwnProperty('price') ? this.data.price : '';
    }

    get unitPrice() {
        return this.data.hasOwnProperty('unitPrice') ? this.data.unitPrice : '';
    }

    get unitPriceReference() {
        return this.data.hasOwnProperty('unitPriceReference') ? this.data.unitPriceReference : '';
    }

    get isVerticalImage() {
        return this.data.hasOwnProperty('isVertical') ? this.data.isVertical : false;
    }

    get priceReference() {
        return this.data.hasOwnProperty('priceReference') ? this.data.priceReference : '';
    }

    get imageUrl() {
        return this.data.hasOwnProperty('imageUrl') ? this.data.imageUrl : '';
    }

    get name() {
        return this.data.hasOwnProperty('name') ? this.data.name : '';
    }

    get quantity() {
        return this.data.hasOwnProperty('quantity') ? this.data.quantity : 0;
    }

    get maxQuantity() {
        return this.data.hasOwnProperty('maxQuantity') ? this.data.maxQuantity : 0;
    }

    get sku() {
        return this.data.hasOwnProperty('sku') ? this.data.sku : '';
    }

    get groupId() {
        return this.data.hasOwnProperty('groupId') ? this.data.groupId : '';
    }

    get type() {
        return this.data.hasOwnProperty('type') ? this.data.type : 0;
    }

    get points() {
        return this.data.hasOwnProperty('points') ? this.data.points : null;
    }

    get pointsRaw() {
      return this.data.hasOwnProperty('pointsRaw') ? this.data.pointsRaw : null;
    }

    get label() {
        return this.data.hasOwnProperty('label') ? this.data.label : null;
    }

    get nonAccumulativePrice() {
        const info = this.data.hasOwnProperty('nonAccumulative') ? this.data.nonAccumulative : null;
        return info && info.hasOwnProperty('price') ? info.price : null;
        //return this.getMessage('NON_ACCUMULATIVE');
    }

    get nonAccumulativeOppor() {
        const info = this.data.hasOwnProperty('nonAccumulative') ? this.data.nonAccumulative : null;
        return info && info.hasOwnProperty('oppor') ? info.oppor : null;
    }

    get isVirtual(){
        return this.data.hasOwnProperty('virtual') ? this.data.virtual : false;
    }

    get isClimatized(){
        return this.data.hasOwnProperty('climatized') ? this.data.climatized : false;
    }

    get url(){
        return this.data.hasOwnProperty('url') ? this.data.url : null;
    }

    get isPack(){
        return this.data.packElements.length ? true : false;
    }

    get packElements(){
        return this.data.packElements;
    }

    get children(){
        return this.data.children;
    }

    get offerChoices(){
        return this._offerChoices.length ? this._offerChoices : null;
    }

    get optionsText(){
        return ProductUtils.getOptionsText(this.data, ' &nbsp;&nbsp; ');
    }

    get messages(){
        if(this.data.hasOwnProperty('messages') && this.data.messages){
            let list = [];
            const messages = this.data.messages;
            for(let i = 0; i < messages.length; i++){
                const code = messages[i].code;
                if( code !== MessagesCodesConstants.NO_STOCK && 
                    code !== MessagesCodesConstants.EXPIRATION_DATE_WARNING && 
                    code !== MessagesCodesConstants.NON_ACCUMULATIVE && 
                    code !== MessagesCodesConstants.TEMPORARY_UNAVAILABLE &&
                    code !== MessagesCodesConstants.NOT_ELIGIBLE){
                    list.push(messages[i].text);
                }
            }
            //console.log('messages ', list);
            return list;
        }
        return null;
    }

    get expiryDateWarning(){
        return this.getMessage(MessagesCodesConstants.EXPIRATION_DATE_WARNING);
    }

    get isTemporaryUnavaiable(){
        return this.getMessage(MessagesCodesConstants.TEMPORARY_UNAVAILABLE);
    }

    get stockErrorMsg(){
        if(this._stockErrorMsg){
            return this._stockErrorMsg;
        }
        return this.getMessage(MessagesCodesConstants.NO_STOCK) || this.getMessage(MessagesCodesConstants.TEMPORARY_UNAVAILABLE);
    }

    get notEligibleMsg(){
        if(this._notEligibleMsg !== false){
            return this._notEligibleMsg;
        }
        return this._notEligibleMsg = this.getMessage(MessagesCodesConstants.NOT_ELIGIBLE);
    }

    set stockErrorMsg(txt) {
        return this._stockErrorMsg = txt;
    }

    getMessage(key){
        if(this.data.hasOwnProperty('messages') && this.data.messages){
            const messages = this.data.messages;
            for(let i = 0; i < messages.length; i++){
                if(messages[i].code === key){
                    return messages[i].text;
                }
            }
        }
        return null;
    }

    isInSegment(segmentId){
        //console.log('product isInSegment', segmentId, this.data.pointsSegments)
        if(this.data.hasOwnProperty('pointsSegments') && this.data.pointsSegments.length){
            //console.log('product isInSegment check', segmentId, this.data.pointsSegments.indexOf(segmentId))
            return this.data.pointsSegments.indexOf(segmentId) > -1;
        }
        return false;
    }

    get isSelectedOffer(){
        return this.data.hasOwnProperty('selected') ? this.data.selected : null;
    }

    get offerVariants(){
        return this.data.hasOwnProperty('variants') ? this.data.variants : null;
    }

    get editOffer(){
        if(this.data.hasOwnProperty('editOffer') && this.data.editOffer){
            let offers = [];
            this.data.editOffer.forEach(product => {
                //console.log('product', product);
                offers.push(new Product(product));
            });
            return offers;
        }
        return null;
    }

    get mubData(){
        return this.data.hasOwnProperty('mubData') ? this.data.mubData : null;
    }

    get stock(){

        //If field not present, return 1 for not error
        if(!this.data.hasOwnProperty('stock')){
            return 1;
        }

        return this.data.stock;
    }

    // get hasStock(){
    //     return this.data.hasOwnProperty('hasStock') ? this.data.hasStock : false;
    // }
}